import { useTranslations } from '@ms/yammer-i18n-react';
import CommonStrings from '@ms/yammer-strings/dist/Common';
import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import Clickable from '@ms/yammer-web-core-ui/dist/components/Clickable';
import { Dismiss20Regular } from '@ms/yammer-web-core-ui/dist/components/FluentUISystemIcon';
import type { FC } from 'react';
import React from 'react';

import { useOverlayNavClose } from '../store';

/**
 * Close control rendered inside the mobile navigation overlay that dismisses the overlay. Matches
 * the web close control (an "x") and returns null when not rendered inside an overlay.
 */
const OverlayNavCloseToggle: FC = () => {
  'use memo';

  const commonT = useTranslations(CommonStrings);
  const onClose = useOverlayNavClose();

  if (!onClose) {
    return null;
  }

  return (
    <Clickable ariaLabel={commonT.commonClose()} unstyled={true} display="inline-block" onClick={onClose}>
      <Block padding={1.5}>
        <Dismiss20Regular />
      </Block>
    </Clickable>
  );
};

export default OverlayNavCloseToggle;
